/* ============================================
   THE ENCHANTED PATH — Haunted Effects JS v6
   
   WHERE TO PUT THIS:
   ─────────────────────────────────────────
   Option A (easiest):
     1. In Shopify admin → Online Store → Themes
     2. Click "Edit code" on your Dawn theme
     3. Open layout/theme.liquid
     4. Paste this entire script inside <script>...</script>
        tags right BEFORE the closing </body> tag
   
   Option B (cleaner):
     1. In "Edit code" → Assets → Add new asset
     2. Create "enchanted-haunted.js"
     3. Paste this code in
     4. In layout/theme.liquid, add this line
        before </body>:
        <script src="{{ 'enchanted-haunted.js' | asset_url }}" defer></script>
   ============================================ */

(function () {
  'use strict';

  var article = document.querySelector('.article-template');
  if (!article) return;

  var OCCULT_SYMBOLS = '☽✦☾⛧♱⚝△▽◆◇⛤⸸✧⊗⊕⌖⍟☿♄♆♇⚸';

  /* ──────────────────────────────────────────
     0. CREATE OVERLAY ELEMENTS
     ────────────────────────────────────────── */
  function createOverlays() {
    var fog1 = document.createElement('div');
    fog1.className = 'enchanted-fog enchanted-fog--layer1';
    article.appendChild(fog1);

    var fog2 = document.createElement('div');
    fog2.className = 'enchanted-fog enchanted-fog--layer2';
    article.appendChild(fog2);

    var p1 = document.createElement('div');
    p1.className = 'enchanted-particles enchanted-particles--gold';
    article.appendChild(p1);

    var p2 = document.createElement('div');
    p2.className = 'enchanted-particles enchanted-particles--purple';
    article.appendChild(p2);

    var vig = document.createElement('div');
    vig.className = 'enchanted-vignette';
    article.appendChild(vig);

    // Grain texture overlay
    var grain = document.createElement('div');
    grain.className = 'enchanted-grain';
    article.appendChild(grain);
  }
  createOverlays();

  /* ──────────────────────────────────────────
     0b. FULL MOON — top left corner
     ────────────────────────────────────────── */
  function createMoon() {
    var contentArea = article.querySelector('.article-template__content');
    if (!contentArea) return;

    var moon = document.createElement('div');
    moon.className = 'enchanted-moon';

    var img = document.createElement('img');
    img.src = 'https://cdn.shopify.com/s/files/1/0680/1529/2598/files/moonfull.png?v=1772668386';
    img.alt = '';
    img.setAttribute('loading', 'lazy');
    moon.appendChild(img);

    // Insert at the top of the content area
    contentArea.insertBefore(moon, contentArea.firstChild);
  }
  createMoon();

  /* ──────────────────────────────────────────
     1. DRIP / MELT LETTERS ON HOVER
     Wraps each letter in headers for the
     CSS drip effect on hover.
     ────────────────────────────────────────── */
  function wrapLettersForDrip(el) {
    var text = el.textContent;
    el.innerHTML = '';
    for (var i = 0; i < text.length; i++) {
      var span = document.createElement('span');
      span.className = 'drip-letter';
      span.textContent = text[i] === ' ' ? '\u00A0' : text[i];
      el.appendChild(span);
    }
  }

  // Wrap all h2 and h3 for drip hover
  article.querySelectorAll('h2, h3').forEach(function (h) {
    wrapLettersForDrip(h);
  });

  /* ──────────────────────────────────────────
     4. HIDDEN SPIRIT MESSAGES
     ────────────────────────────────────────── */
  var spiritMessages = {
    'mugwort':       'The dreamwalker\'s herb... it opens the veil',
    'lavender':      'Used to calm restless spirits since ancient times',
    'sage':          'Not just cleansing — it demands respect',
    'rosemary':      'The herb of remembrance... and the dead',
    'thyme':         'The Fae are drawn to where thyme grows wild',
    'wormwood':      'Absinthe\'s dark heart... visions dwell within',
    'yarrow':        'Warriors carried it. Witches cast with it.',
    'mandrake':      'Its scream can shatter the unprepared mind',
    'belladonna':    'Beautiful lady... deadly nightshade whispers',
    'chamomile':     'A gentle guardian hiding fierce power',
    'elderflower':   'The Elder Mother watches over this one',
    'nettle':        'Sting of protection. Brew of courage.',
    'henbane':       'The flying ointment... tread carefully',
    'vervain':       'Sacred to druids. Feared by the unclean.',
    'rue':           'The herb of grace... and bitter truth',
    'labradorite':   'The stone of hidden realms... look deeper',
    'obsidian':      'Born of fire. A mirror to your shadow self.',
    'amethyst':      'It has guarded against dark spirits for millennia',
    'moonstone':     'The moon remembers what the sun forgets',
    'crystal':       'Every crystal holds a memory of the earth',
    'quartz':        'An amplifier... be careful what you amplify',
    'onyx':          'A shield against what lurks in the unseen',
    'tourmaline':    'It absorbs what was never meant for you',
    'bloodstone':    'Ancient warriors knew its secret well',
    'selenite':      'Named for the moon goddess herself',
    'jade':          'The stone of immortality in the old world',
    'carnelian':     'Fire trapped in stone. Courage made solid.',
    'ritual':        'Every ritual is a conversation with the unseen',
    'magic':         'The old word was "magick" for a reason',
    'astral':        'Your spirit has traveled here before',
    'veil':          'Thinner than you think... especially now',
    'sacred':        'This ground remembers those who came before',
    'spirit':        'They are closer than you realize',
    'shadow':        'Not evil — just the self you haven\'t met',
    'moon':          'She sees everything. She forgets nothing.',
    'darkness':      'Not the absence of light... the presence of mystery',
    'altar':         'A doorway disguised as a table',
    'sigil':         'A symbol charged with will. Handle with care.',
    'incantation':   'Words have weight in the spaces between worlds',
    'omen':          'The universe is always speaking... are you listening?',
    'prophecy':      'Time is a circle, not a line',
    'enchantment':   'The old craft of binding will to word',
    'divination':    'Lifting the curtain on what is yet to be',
    'talisman':      'Protection wrapped in intention',
    'familiar':      'Not a pet. A partner from the other side.',
    'coven':         'Power shared is power multiplied',
    'grimoire':      'Every grimoire has a spirit of its own',
    'potion':        'Alchemy of the green world',
    'cauldron':      'Where transformation begins',
    'solstice':      'When the world holds its breath',
    'equinox':       'Balance... the fulcrum of all magic',
    'sabbat':        'The wheel turns. The old ways endure.',
    'protection':    'The first lesson... and the most important',
    'ancestors':     'They walk beside you still',
    'intuition':     'Your oldest and most trusted sense',
    'energy':        'Everything vibrates. Everything speaks.',
    'intention':     'The spark before the flame',
    'meditation':    'The silence between the worlds',
    'cleansing':     'What remains when the unwanted falls away',
    'blessing':      'Light shaped by loving hands',
    'hex':           'A word older than the language it lives in',
    'curse':         'Energy returns threefold. Remember that.',
    'oracle':        'The voice of what has always been known',
    'phantom':       'Not all visitors announce themselves',
    'ethereal':      'Between here and there... that is where power lives',
    'awakening':     'You were never truly asleep'
  };

  function wrapSpiritWords() {
    var contentArea = article.querySelector('.article-template__content');
    if (!contentArea) return;

    var keywords = Object.keys(spiritMessages);
    var pattern = new RegExp('\\b(' + keywords.join('|') + ')\\b', 'gi');

    var walker = document.createTreeWalker(contentArea, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var tag = node.parentElement ? node.parentElement.tagName : '';
        if (tag === 'SCRIPT' || tag === 'STYLE') return NodeFilter.FILTER_REJECT;
        if (node.parentElement && node.parentElement.classList.contains('spirit-word')) return NodeFilter.FILTER_REJECT;
        if (['P', 'LI', 'BLOCKQUOTE', 'SPAN', 'EM', 'STRONG'].indexOf(tag) === -1) return NodeFilter.FILTER_SKIP;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var textNodes = [];
    var node;
    while ((node = walker.nextNode())) textNodes.push(node);

    textNodes.forEach(function (textNode) {
      var text = textNode.nodeValue;
      if (!pattern.test(text)) return;
      pattern.lastIndex = 0;

      var frag = document.createDocumentFragment();
      var lastIndex = 0;
      var match;

      while ((match = pattern.exec(text)) !== null) {
        if (match.index > lastIndex) frag.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
        var span = document.createElement('span');
        span.className = 'spirit-word';
        span.setAttribute('data-spirit', spiritMessages[match[1].toLowerCase()] || '');
        span.textContent = match[0];
        frag.appendChild(span);
        lastIndex = pattern.lastIndex;
      }
      if (lastIndex < text.length) frag.appendChild(document.createTextNode(text.slice(lastIndex)));
      textNode.parentNode.replaceChild(frag, textNode);
    });
  }
  setTimeout(wrapSpiritWords, 500);

  /* ──────────────────────────────────────────
     5. HANDWRITTEN INSCRIPTION AT BOTTOM
     ────────────────────────────────────────── */
  var inscriptionText = 'Weve Been Expecting You';

  function createInscription() {
    var contentArea = article.querySelector('.article-template__content');
    if (!contentArea) return null;

    var container = document.createElement('div');
    container.className = 'spirit-inscription';

    var textEl = document.createElement('span');
    textEl.className = 'spirit-inscription__text';
    textEl.textContent = inscriptionText;
    container.appendChild(textEl);

    contentArea.appendChild(container);
    return container;
  }

  var inscription = createInscription();
  if (inscription) {
    var inscriptionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          setTimeout(function () { inscription.classList.add('revealed'); }, 400);
          inscriptionObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    inscriptionObserver.observe(inscription);
  }

  /* ──────────────────────────────────────────
     6. GHOST SMOKE CURSOR TRAIL
     ────────────────────────────────────────── */
  var lastSmokeTime = 0;

  function createSmokeParticle(x, y) {
    var particle = document.createElement('div');
    particle.className = 'smoke-particle';
    var size = 4 + Math.random() * 8;
    var hue = Math.random() > 0.5 ? '45, 60%' : '260, 30%';
    var opacity = 0.2 + Math.random() * 0.25;

    particle.style.cssText =
      'left:' + (x - size / 2) + 'px;top:' + (y - size / 2) + 'px;width:' + size +
      'px;height:' + size + 'px;background:radial-gradient(circle, hsla(' + hue + ',' +
      (opacity * 100) + '%) 0%, transparent 70%);opacity:' + opacity + ';';

    document.body.appendChild(particle);
    var driftX = (Math.random() - 0.5) * 40;
    var driftY = -20 - Math.random() * 30;
    var growTo = size * (2 + Math.random() * 2);

    particle.animate([
      { transform: 'translate(0, 0) scale(1)', opacity: opacity },
      { transform: 'translate(' + driftX + 'px, ' + driftY + 'px) scale(' + (growTo / size) + ')', opacity: 0 }
    ], { duration: 900 + Math.random() * 600, easing: 'ease-out', fill: 'forwards' })
    .onfinish = function () { particle.remove(); };
  }

  if (!('ontouchstart' in window)) {
    document.addEventListener('mousemove', function (e) {
      var now = Date.now();
      if (now - lastSmokeTime < 35) return;
      lastSmokeTime = now;
      createSmokeParticle(e.clientX, e.clientY);
      if (Math.random() > 0.65) {
        setTimeout(function () {
          createSmokeParticle(e.clientX + (Math.random() - 0.5) * 12, e.clientY + (Math.random() - 0.5) * 12);
        }, 50);
      }
    });
  }

  /* ──────────────────────────────────────────
     7. SHADOW FIGURE
     ────────────────────────────────────────── */
  var shadowFigure = document.createElement('div');
  shadowFigure.className = 'shadow-figure';
  document.body.appendChild(shadowFigure);

  var lastScrollY = window.scrollY;
  var scrollAccumulator = 0;
  var shadowCooldown = false;
  var figureTimeout = null;
  var firstShadowShown = false;

  function showShadowFigure() {
    if (shadowCooldown) return;
    shadowCooldown = true;

    var side = Math.random() > 0.5 ? 'right' : 'left';
    shadowFigure.style.top = (15 + Math.random() * 55) + '%';
    shadowFigure.style[side] = '-5px';
    shadowFigure.style[side === 'left' ? 'right' : 'left'] = 'auto';
    shadowFigure.offsetHeight;
    shadowFigure.classList.add('visible');

    figureTimeout = setTimeout(function () {
      shadowFigure.classList.remove('visible');
      setTimeout(function () {
        shadowCooldown = false;
        scrollAccumulator = 0;
      }, 20000 + Math.random() * 20000);
    }, 500 + Math.random() * 400);
  }

  window.addEventListener('scroll', function () {
    var delta = Math.abs(window.scrollY - lastScrollY);
    lastScrollY = window.scrollY;
    scrollAccumulator += delta;

    if (!firstShadowShown && scrollAccumulator > 600) {
      firstShadowShown = true;
      showShadowFigure();
      return;
    }
    if (firstShadowShown && scrollAccumulator > 800 + Math.random() * 700) {
      showShadowFigure();
    }
  }, { passive: true });

  /* ──────────────────────────────────────────
     8. SPIDER CRAWL
     
     Cycles between 3 spider frames for a
     walking animation along the bottom of
     the screen. Pauses randomly to look around.
     ────────────────────────────────────────── */
  var SPIDER_FRAMES = [
    'https://cdn.shopify.com/s/files/1/0680/1529/2598/files/jumper1.png?v=1770315152',
    'https://cdn.shopify.com/s/files/1/0680/1529/2598/files/jumper2.png?v=1770315152',
    'https://cdn.shopify.com/s/files/1/0680/1529/2598/files/jumper3.png?v=1770315152'
  ];

  function initSpider() {
    // Preload frames
    SPIDER_FRAMES.forEach(function (src) {
      var img = new Image();
      img.src = src;
    });

    var spider = document.createElement('img');
    spider.className = 'enchanted-spider';
    spider.src = SPIDER_FRAMES[0];
    spider.alt = '';
    document.body.appendChild(spider);

    var frameIndex = 0;
    var animFrameTimer = null;

    function startFrameAnimation() {
      animFrameTimer = setInterval(function () {
        frameIndex = (frameIndex + 1) % SPIDER_FRAMES.length;
        spider.src = SPIDER_FRAMES[frameIndex];
      }, 150);
    }

    function stopFrameAnimation() {
      clearInterval(animFrameTimer);
    }

    function crawl() {
      var screenWidth = window.innerWidth;
      var goingRight = Math.random() > 0.5;
      var currentX = goingRight ? -80 : screenWidth + 80;
      var speed = 0.8 + Math.random() * 0.6;
      var paused = false;
      var pauseCountdown = 200 + Math.floor(Math.random() * 300);

      spider.style.transform = goingRight ? 'scaleX(1)' : 'scaleX(-1)';
      spider.style.left = currentX + 'px';

      startFrameAnimation();

      function step() {
        if (paused) return;

        currentX += goingRight ? speed : -speed;
        spider.style.left = currentX + 'px';
        pauseCountdown--;

        if (pauseCountdown <= 0 && Math.random() > 0.99) {
          paused = true;
          stopFrameAnimation();

          setTimeout(function () {
            paused = false;
            pauseCountdown = 150 + Math.floor(Math.random() * 200);
            startFrameAnimation();
            requestAnimationFrame(step);
          }, 800 + Math.random() * 1200);
          return;
        }

        if ((goingRight && currentX > screenWidth + 80) || (!goingRight && currentX < -80)) {
          stopFrameAnimation();
          setTimeout(crawl, 30000 + Math.random() * 30000);
          return;
        }

        requestAnimationFrame(step);
      }

      requestAnimationFrame(step);
    }

    // First crawl after 8-15 seconds
    setTimeout(crawl, 8000 + Math.random() * 7000);
  }

  if (!('ontouchstart' in window)) {
    initSpider();
  }

  /* ──────────────────────────────────────────
     10. SCROLL-TRIGGERED FADE-IN
     Marks h2, h3, p, blockquote, ul, ol, hr
     as fade targets and reveals them on scroll
     ────────────────────────────────────────── */
  function initScrollFade() {
    var contentArea = article.querySelector('.article-template__content');
    if (!contentArea) return;

    // Mark elements that are below the initial viewport fold
    var elements = contentArea.querySelectorAll('h2, h3, p, blockquote, ul, ol, hr, img');
    elements.forEach(function (el) {
      // Skip the first few elements (they use the page-load fadeUp)
      var rect = el.getBoundingClientRect();
      if (rect.top > window.innerHeight * 0.8) {
        el.classList.add('enchanted-fade-target');
      }
    });

    var fadeObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('enchanted-visible');
          fadeObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    contentArea.querySelectorAll('.enchanted-fade-target').forEach(function (el) {
      fadeObserver.observe(el);
    });
  }

  // Run after other effects have had time to set up
  setTimeout(initScrollFade, 800);

  /* ──────────────────────────────────────────
     CLEANUP
     ────────────────────────────────────────── */
  window.addEventListener('beforeunload', function () {
    if (figureTimeout) clearTimeout(figureTimeout);
    if (inscription && inscriptionObserver) inscriptionObserver.disconnect();
  });

})();